import { render, staticRenderFns } from "./ChangeBid.vue?vue&type=template&id=3106b054&scoped=true&"
import script from "./ChangeBid.vue?vue&type=script&lang=js&"
export * from "./ChangeBid.vue?vue&type=script&lang=js&"
import style0 from "./ChangeBid.vue?vue&type=style&index=0&id=3106b054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3106b054",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VDialog,VForm,VRow,VSnackbar})
